import { gql } from '@apollo/client';
import { maritimeDirectoryPortModel } from 'model';

export interface AddMaritimeDirectoryPortInput {
  maritimeDirectoryId: string;
  portId: string;
  isActive: boolean;
}

export interface UpdateMaritimeDirectoryPortInput {
  id: string;
  isActive: boolean;
}

export interface DeleteMaritimeDirectoryPortInput {
  id: string;
}

export interface MaritimeDirectoryPortResponse {
  maritimeDirectoryPort: Partial<maritimeDirectoryPortModel>;
}

export interface MaritimeDirectoryPortsResponse {
  maritimeDirectoryPorts: Partial<maritimeDirectoryPortModel>[];
}

export interface AddPortToCounterPartyInput {
  input: {
    counterPartyId: string;
    portId: string;
  }
}

export interface AddPortToCounterPartyResponse {
  maritimeDirectoryPort?: Partial<maritimeDirectoryPortModel>;
}

export const ADD_MARITIME_DIRECTORY_PORT = gql`
  mutation addMaritimeDirectoryPort($input: AddMaritimeDirectoryPortInput!) {
    maritimeDirectoryPort: addMaritimeDirectoryPort(input: $input) {
      id
    }
  }
`;

export const ADD_MARITIME_DIRECTORY_PORTS = gql`
  mutation addMaritimeDirectoryPorts($input: [AddMaritimeDirectoryPortInput!]!) {
    maritimeDirectoryPorts: addMaritimeDirectoryPorts(input: $input) {
      id
    }
  }
`;

export const UPDATE_MARITIME_DIRECTORY_PORT = gql`
  mutation updateMaritimeDirectoryPort($input: UpdateMaritimeDirectoryPortInput!) {
    maritimeDirectoryPort: updateMaritimeDirectoryPort(input: $input) {
      id
      isActive
    }
  }
`;

export const DELETE_MARITIME_DIRECTORY_PORT = gql`
  mutation deleteMaritimeDirectoryPort($input: DeleteMaritimeDirectoryPortInput!) {
    deleteMaritimeDirectoryPort(input: $input)
  }
`;

export const ADD_PORT_TO_COUNTER_PARTY = gql`
  mutation addPortToCounterParty($input: AddPortToCounterPartyDtoInput!) {
    maritimeDirectoryPort: addPortToCounterParty(input: $input) {
      id
    }
  }
`;
